//DEV
/*export const S3_CONNECTION = {
    accessKeyId: "iscaps",
    secretAccessKey: "JE8sB82aJjtLGSK2F56eztDUkk8axsGb",
    endpoint: "https://s3.dexagroup.com",
    s3ForcePathStyle: true,
    signatureVersion: "v4"
}*/

//PROD
// export const S3_CONNECTION = {
//     accessKeyId: "iscaps-prod",
//     secretAccessKey: "W2kehDvWp6HEVmbfBdqBJUkNtQ2rEVm",
//     endpoint: "https://s3.dexagroup.com",
//     s3ForcePathStyle: true,
//     signatureVersion: "v4"
// }
export const S3_CONNECTION = {
    accessKeyId: "am-iscaps-pro",
    secretAccessKey: "6TMrHxWxoQA6bt1eibsgHvf5XkcHZPsiZbVTGQth",
    endpoint: "https://s3.anugrah-argon.com",
    s3ForcePathStyle: true,
    signatureVersion: "v4"
}